var items = {
  "block.minecraft.air": "himpapawid",
  "block.minecraft.stone": "bato",
  "block.minecraft.granite": "granayt",
  "block.minecraft.polished_granite": "makinis na granayt",
  "block.minecraft.diorite": "diyorayt",
  "block.minecraft.polished_diorite": "makinis na diyorayt",
  "block.minecraft.andesite": "andesayt",
  "block.minecraft.polished_andesite": "makinis na andesayt",
  "block.minecraft.grass_block": "bloke ng damo",
  "block.minecraft.dirt": "lupa",
  "block.minecraft.coarse_dirt": "lupang magaspang",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "krimsong nylium",
  "block.minecraft.warped_nylium": "warped nylium",
  "block.minecraft.cobblestone": "byakbato",
  "block.minecraft.oak_planks": "robleng tabla",
  "block.minecraft.spruce_planks": "pinong tabla",
  "block.minecraft.birch_planks": "birkeng tabla",
  "block.minecraft.jungle_planks": "gubat na tabla",
  "block.minecraft.acacia_planks": "akasyang tabla",
  "block.minecraft.dark_oak_planks": "maitim na robleng tabla",
  "block.minecraft.crimson_planks": "krimsong tabla",
  "block.minecraft.warped_planks": "nakiwal na tabla",
  "block.minecraft.oak_sapling": "halamang roble",
  "block.minecraft.spruce_sapling": "halamang pino",
  "block.minecraft.birch_sapling": "halamang birch",
  "block.minecraft.jungle_sapling": "halamang gubat",
  "block.minecraft.acacia_sapling": "halamang akasya",
  "block.minecraft.dark_oak_sapling": "halamang maitim na roble",
  "block.minecraft.bedrock": "batong matigas",
  "block.minecraft.sand": "buhangin",
  "block.minecraft.red_sand": "pulang buhangin",
  "block.minecraft.gravel": "graba",
  "block.minecraft.gold_ore": "batong ginto",
  "block.minecraft.iron_ore": "batong bakal",
  "block.minecraft.coal_ore": "batong karbon",
  "block.minecraft.nether_gold_ore": "impyer mambatong ginto",
  "block.minecraft.oak_log": "robleng troso",
  "block.minecraft.spruce_log": "pinong troso",
  "block.minecraft.birch_log": "birkeng troso",
  "block.minecraft.jungle_log": "gubat na troso",
  "block.minecraft.acacia_log": "akasyang troso",
  "block.minecraft.dark_oak_log": "maitim na robleng troso",
  "block.minecraft.crimson_stem": "krimsong tangkay",
  "block.minecraft.warped_stem": "warped stem",
  "block.minecraft.stripped_oak_log": "nabalatang robleng troso",
  "block.minecraft.stripped_spruce_log": "nabalatang pinong troso",
  "block.minecraft.stripped_birch_log": "nabalatang birkeng troso",
  "block.minecraft.stripped_jungle_log": "nabalatang gubat na troso",
  "block.minecraft.stripped_acacia_log": "nabalatang akasyang troso",
  "block.minecraft.stripped_dark_oak_log": "nabalatang maitim na robleng troso",
  "block.minecraft.stripped_crimson_stem": "nabalatang krimsong tangkay",
  "block.minecraft.stripped_warped_stem": "striped warped stem",
  "block.minecraft.stripped_oak_wood": "nabalatang robleng kahoy",
  "block.minecraft.stripped_spruce_wood": "nabalatang pinong kahoy",
  "block.minecraft.stripped_birch_wood": "nabalatang birkeng kahoy",
  "block.minecraft.stripped_jungle_wood": "nabalatang gubat na kahoy",
  "block.minecraft.stripped_acacia_wood": "nabalatang akasyang kahoy",
  "block.minecraft.stripped_dark_oak_wood": "nabalatang maitim na robleng kahoy",
  "block.minecraft.stripped_crimson_hyphae": "nabalatang krimsong hyphae",
  "block.minecraft.stripped_warped_hyphae": "stripped warped hyphae",
  "block.minecraft.oak_wood": "robleng kahoy",
  "block.minecraft.spruce_wood": "pinong kahoy",
  "block.minecraft.birch_wood": "birkeng kahoy",
  "block.minecraft.jungle_wood": "gubatang kahoy",
  "block.minecraft.acacia_wood": "akasyang kahoy",
  "block.minecraft.dark_oak_wood": "madilim na robleng kahoy",
  "block.minecraft.crimson_hyphae": "krimsong hyphae",
  "block.minecraft.warped_hyphae": "warped hypae",
  "block.minecraft.oak_leaves": "robleng dahog",
  "block.minecraft.spruce_leaves": "pinong dahon",
  "block.minecraft.birch_leaves": "birkeng dahon",
  "block.minecraft.jungle_leaves": "gubatang dahon",
  "block.minecraft.acacia_leaves": "akasyang dahon",
  "block.minecraft.dark_oak_leaves": "madilim na robleng dahon",
  "block.minecraft.sponge": "espongha",
  "block.minecraft.wet_sponge": "basang espongha",
  "block.minecraft.glass": "salamin",
  "block.minecraft.lapis_ore": "batong lapis lazuli",
  "block.minecraft.lapis_block": "bloke ng lapis lazuli",
  "block.minecraft.dispenser": "taga-bigay",
  "block.minecraft.sandstone": "batubuhangin",
  "block.minecraft.chiseled_sandstone": "buhang-pait",
  "block.minecraft.cut_sandstone": "ginupit na sandstone",
  "block.minecraft.note_block": "bloke ng nota",
  "block.minecraft.powered_rail": "lakas-riles",
  "block.minecraft.detector_rail": "ramdam-riles",
  "block.minecraft.sticky_piston": "pistong malagkit",
  "block.minecraft.cobweb": "sapot",
  "block.minecraft.grass": "damo",
  "block.minecraft.fern": "eletso",
  "block.minecraft.dead_bush": "patay na palumpong",
  "block.minecraft.seagrass": "damong dagat",
  "block.minecraft.sea_pickle": "atsarang dagat",
  "block.minecraft.piston": "piston",
  "block.minecraft.white_wool": "lanang puti",
  "block.minecraft.orange_wool": "lanang kahel",
  "block.minecraft.magenta_wool": "lanang mahenta",
  "block.minecraft.light_blue_wool": "lanang langit",
  "block.minecraft.yellow_wool": "lanang dilaw",
  "block.minecraft.lime_wool": "lanang dayap",
  "block.minecraft.pink_wool": "lanang rosas",
  "block.minecraft.gray_wool": "lanang abo",
  "block.minecraft.light_gray_wool": "lanang pilak",
  "block.minecraft.cyan_wool": "lanang cyan",
  "block.minecraft.purple_wool": "lanang lila",
  "block.minecraft.blue_wool": "lanang bughaw",
  "block.minecraft.brown_wool": "lanang kayumanggi",
  "block.minecraft.green_wool": "lanang luntian",
  "block.minecraft.red_wool": "lanang pula",
  "block.minecraft.black_wool": "lanang itim",
  "block.minecraft.dandelion": "ngiping leon",
  "block.minecraft.poppy": "amapola",
  "block.minecraft.blue_orchid": "bughaw na orkidia",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "bughaw na ligaw na bulaklak",
  "block.minecraft.red_tulip": "tulipang pula",
  "block.minecraft.orange_tulip": "tulipang kahel",
  "block.minecraft.white_tulip": "tulipang puti",
  "block.minecraft.pink_tulip": "rosas na tulip",
  "block.minecraft.oxeye_daisy": "oxeye na daisy",
  "block.minecraft.cornflower": "cornflower",
  "block.minecraft.lily_of_the_valley": "liryo ng lambak",
  "block.minecraft.wither_rose": "rosas ng wither",
  "block.minecraft.brown_mushroom": "kayumangging kabute",
  "block.minecraft.red_mushroom": "pulang kabute",
  "block.minecraft.crimson_fungus": "kabuting-krimson",
  "block.minecraft.warped_fungus": "kabuting-kiwal",
  "block.minecraft.crimson_roots": "krimsong ugat",
  "block.minecraft.warped_roots": "warped ugat",
  "block.minecraft.nether_sprouts": "impyer usbong",
  "block.minecraft.weeping_vines": "lumuluhang baging",
  "block.minecraft.twisting_vines": "pulupot na baging",
  "block.minecraft.sugar_cane": "tubo",
  "block.minecraft.kelp": "kelp",
  "block.minecraft.bamboo": "kawayan",
  "block.minecraft.gold_block": "gintong bloke",
  "block.minecraft.iron_block": "bakal na bloke",
  "block.minecraft.oak_slab": "robleng tilad",
  "block.minecraft.spruce_slab": "pinong tilad",
  "block.minecraft.birch_slab": "birkeng tilad",
  "block.minecraft.jungle_slab": "gubat na tilad",
  "block.minecraft.acacia_slab": "akasyang tilad",
  "block.minecraft.dark_oak_slab": "maitim na robleng tilad",
  "block.minecraft.crimson_slab": "krimsong tilad",
  "block.minecraft.warped_slab": "nakiwal na tilad",
  "block.minecraft.stone_slab": "tilang bato",
  "block.minecraft.smooth_stone_slab": "makinis na tilang bato",
  "block.minecraft.sandstone_slab": "tilang batubuhangin",
  "block.minecraft.cut_sandstone_slab": "hiniwang tilang batubuhangin",
  "block.minecraft.petrified_oak_slab": "nanigas na robleng tilad",
  "block.minecraft.cobblestone_slab": "byakbatong tilad",
  "block.minecraft.brick_slab": "laryong tilad",
  "block.minecraft.stone_brick_slab": "laryong batong tilad",
  "block.minecraft.nether_brick_slab": "impyer laryong tilad",
  "block.minecraft.quartz_slab": "tilang kwarta",
  "block.minecraft.red_sandstone_slab": "tilang pulang batubuhangin",
  "block.minecraft.cut_red_sandstone_slab": "hiniwang tilang pulang batubuhangin",
  "block.minecraft.purpur_slab": "tilad na purpur",
  "block.minecraft.prismarine_slab": "prismaring tilad",
  "block.minecraft.prismarine_brick_slab": "laryo ng prismaring tilad",
  "block.minecraft.dark_prismarine_slab": "maitim na prismaring tilad",
  "block.minecraft.smooth_quartz": "makinis na kuwartang bloke",
  "block.minecraft.smooth_red_sandstone": "mapulang buhang-buli",
  "block.minecraft.smooth_sandstone": "buhang-buli",
  "block.minecraft.smooth_stone": "makinis na bato",
  "block.minecraft.bricks": "mga ladrilyo",
  "block.minecraft.tnt": "bomba",
  "block.minecraft.bookshelf": "istante ng aklat",
  "block.minecraft.mossy_cobblestone": "byakbatong malumot",
  "block.minecraft.obsidian": "obsidiyano",
  "block.minecraft.torch": "ilaw",
  "block.minecraft.end_rod": "end na pamalo",
  "block.minecraft.chorus_plant": "korong halaman",
  "block.minecraft.chorus_flower": "korong bulaklak",
  "block.minecraft.purpur_block": "bloke ng purpur",
  "block.minecraft.purpur_pillar": "poste ng purpur",
  "block.minecraft.purpur_stairs": "hagdanang purpur",
  "block.minecraft.spawner": "panlikhaan",
  "block.minecraft.oak_stairs": "robleng hagdanan",
  "block.minecraft.chest": "baul",
  "block.minecraft.diamond_ore": "batong brilyante",
  "block.minecraft.diamond_block": "brilyanteng bloke",
  "block.minecraft.crafting_table": "gawaan",
  "block.minecraft.farmland": "bukiran",
  "block.minecraft.furnace": "pugon",
  "block.minecraft.ladder": "hagdan",
  "block.minecraft.rail": "riles",
  "block.minecraft.cobblestone_stairs": "byakbatong hagdan",
  "block.minecraft.lever": "baras",
  "block.minecraft.stone_pressure_plate": "apakan na bato",
  "block.minecraft.oak_pressure_plate": "robleng apakan",
  "block.minecraft.spruce_pressure_plate": "pinong apakan",
  "block.minecraft.birch_pressure_plate": "birkeng apakan",
  "block.minecraft.jungle_pressure_plate": "gubat na apakan",
  "block.minecraft.acacia_pressure_plate": "akasyang apakan",
  "block.minecraft.dark_oak_pressure_plate": "maitim na robleng apakan",
  "block.minecraft.crimson_pressure_plate": "krimsong apakan",
  "block.minecraft.warped_pressure_plate": "nakiwal na apakan",
  "block.minecraft.polished_blackstone_pressure_plate": "makinis na batong-itim na apakan",
  "block.minecraft.redstone_ore": "mambatong kulog",
  "block.minecraft.redstone_torch": "kulog sulo",
  "block.minecraft.snow": "niyebe",
  "block.minecraft.ice": "yelo",
  "block.minecraft.snow_block": "bloke ng niyebe",
  "block.minecraft.cactus": "kakto",
  "block.minecraft.clay": "luwad",
  "block.minecraft.jukebox": "musikahon",
  "block.minecraft.oak_fence": "robleng bakod",
  "block.minecraft.spruce_fence": "pinong bakod",
  "block.minecraft.birch_fence": "birkeng bakod",
  "block.minecraft.jungle_fence": "gubat na bakod",
  "block.minecraft.acacia_fence": "akasyang bakod",
  "block.minecraft.dark_oak_fence": "madilim na robleng bakod",
  "block.minecraft.crimson_fence": "krimsong bakod",
  "block.minecraft.warped_fence": "nakiwal na bakod",
  "block.minecraft.pumpkin": "kalabasa",
  "block.minecraft.carved_pumpkin": "inukit na kalabasa",
  "block.minecraft.netherrack": "impyersabitan",
  "block.minecraft.soul_sand": "kaluwan hangin",
  "block.minecraft.soul_soil": "kaluwan lupa",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "makinis na basalto",
  "block.minecraft.soul_torch": "kaluwan sulo",
  "block.minecraft.glowstone": "sindin-bato",
  "block.minecraft.jack_o_lantern": "diyak ng parol",
  "block.minecraft.oak_trapdoor": "maliit na robleng pinto",
  "block.minecraft.spruce_trapdoor": "maliit na pinong pinto",
  "block.minecraft.birch_trapdoor": "maliit na birkeng pinto",
  "block.minecraft.jungle_trapdoor": "maliit na gubat na pinto",
  "block.minecraft.acacia_trapdoor": "maliit na akasyang pinto",
  "block.minecraft.dark_oak_trapdoor": "maliit na maitim na robleng pinto",
  "block.minecraft.crimson_trapdoor": "maliit na krimsong pinto",
  "block.minecraft.warped_trapdoor": "warped pinto ng bitag",
  "block.minecraft.infested_stone": "mauod na bato",
  "block.minecraft.infested_cobblestone": "mauod na byakbato",
  "block.minecraft.infested_stone_bricks": "mauod na batong laryo",
  "block.minecraft.infested_mossy_stone_bricks": "mauod na malumot batong laryo",
  "block.minecraft.infested_cracked_stone_bricks": "mauod na nabyak batong laryo",
  "block.minecraft.infested_chiseled_stone_bricks": "mauod na pinait batong laryo",
  "block.minecraft.stone_bricks": "laryong bato",
  "block.minecraft.mossy_stone_bricks": "laryong lumot",
  "block.minecraft.cracked_stone_bricks": "laryong sira",
  "block.minecraft.chiseled_stone_bricks": "laryong pinait",
  "block.minecraft.brown_mushroom_block": "bloke ng kayumangging kabute",
  "block.minecraft.red_mushroom_block": "bloke ng pulang kabute",
  "block.minecraft.mushroom_stem": "tangkay ng kabute",
  "block.minecraft.iron_bars": "rehas",
  "block.minecraft.chain": "tanikala",
  "block.minecraft.glass_pane": "bintana",
  "block.minecraft.melon": "melon",
  "block.minecraft.vine": "baging",
  "block.minecraft.oak_fence_gate": "robleng tarangkahan",
  "block.minecraft.spruce_fence_gate": "pinong tarangkahan",
  "block.minecraft.birch_fence_gate": "birkeng tarangkahan",
  "block.minecraft.jungle_fence_gate": "gubat na tarangkahan",
  "block.minecraft.acacia_fence_gate": "akasyang tarangkahan",
  "block.minecraft.dark_oak_fence_gate": "maitim na robleng tarangkahan",
  "block.minecraft.crimson_fence_gate": "krimsong tarangkahan",
  "block.minecraft.warped_fence_gate": "nakiwal na tarangkahan",
  "block.minecraft.brick_stairs": "hagdanang laryo",
  "block.minecraft.stone_brick_stairs": "hagdanang laryong bato",
  "block.minecraft.mycelium": "maisiliyum",
  "block.minecraft.lily_pad": "dahon ng liryo",
  "block.minecraft.nether_bricks": "impyer laryo",
  "block.minecraft.cracked_nether_bricks": "byak impyer laryo",
  "block.minecraft.chiseled_nether_bricks": "pinait impyer laryo",
  "block.minecraft.nether_brick_fence": "impyer laryong bakod",
  "block.minecraft.nether_brick_stairs": "impyer laryong hagdan",
  "block.minecraft.enchanting_table": "mesa ng pagrarahuyo",
  "block.minecraft.end_portal_frame": "balangkas ng lagusan sa end",
  "block.minecraft.end_stone": "end na bato",
  "block.minecraft.end_stone_bricks": "end na laryong bato",
  "block.minecraft.dragon_egg": "itlog ng dragon",
  "block.minecraft.redstone_lamp": "kulog lampara",
  "block.minecraft.sandstone_stairs": "hagdanang batubuhangin",
  "block.minecraft.emerald_ore": "batong esmeralda",
  "block.minecraft.ender_chest": "end na baul",
  "block.minecraft.tripwire_hook": "sabitan ng dapaan",
  "block.minecraft.emerald_block": "esmeraldang bloke",
  "block.minecraft.spruce_stairs": "pinong hagdanan",
  "block.minecraft.birch_stairs": "birkeng hagdanan",
  "block.minecraft.jungle_stairs": "gubat na hagdanan",
  "block.minecraft.crimson_stairs": "krimsong hagdanan",
  "block.minecraft.warped_stairs": "nakiwal na hagdanan",
  "block.minecraft.command_block": "bloke ng utos",
  "block.minecraft.beacon": "parola",
  "block.minecraft.cobblestone_wall": "byakbatong pader",
  "block.minecraft.mossy_cobblestone_wall": "malumot byakbatong pader",
  "block.minecraft.brick_wall": "pader na laryo",
  "block.minecraft.prismarine_wall": "pader na prismarin",
  "block.minecraft.red_sandstone_wall": "pader na mapulang batubuhangin",
  "block.minecraft.mossy_stone_brick_wall": "pader na laryong lumot",
  "block.minecraft.granite_wall": "pader na granayt",
  "block.minecraft.stone_brick_wall": "pader na laryong bato",
  "block.minecraft.nether_brick_wall": "impyer laryong pader",
  "block.minecraft.andesite_wall": "pader na andesayt",
  "block.minecraft.red_nether_brick_wall": "pulang impyer laryong pader",
  "block.minecraft.sandstone_wall": "pader na batubuhangin",
  "block.minecraft.end_stone_brick_wall": "pader na end na laryong bato",
  "block.minecraft.diorite_wall": "pader na dayorait",
  "block.minecraft.blackstone_wall": "pader na batong-itim",
  "block.minecraft.polished_blackstone_wall": "pader na makinis na batong-itim",
  "block.minecraft.polished_blackstone_brick_wall": "pader na makinis na batong-itim na laryo",
  "block.minecraft.stone_button": "batong pindutan",
  "block.minecraft.oak_button": "robleng pindutan",
  "block.minecraft.spruce_button": "pinong pindutan",
  "block.minecraft.birch_button": "birkeng pindutan",
  "block.minecraft.jungle_button": "gubat na pindutan",
  "block.minecraft.acacia_button": "akasyang pindutan",
  "block.minecraft.dark_oak_button": "maitim na robleng pindutan",
  "block.minecraft.crimson_button": "krimsong pindutan",
  "block.minecraft.warped_button": "nakiwal na pindutan",
  "block.minecraft.polished_blackstone_button": "makinis na batong-itim na pindutan",
  "block.minecraft.anvil": "palihan",
  "block.minecraft.chipped_anvil": "basag na palihan",
  "block.minecraft.damaged_anvil": "nasirang palihan",
  "block.minecraft.trapped_chest": "umangbaul",
  "block.minecraft.light_weighted_pressure_plate": "magaang apakan",
  "block.minecraft.heavy_weighted_pressure_plate": "mabigat na apakan",
  "block.minecraft.daylight_detector": "detektor ng liwanag ng araw",
  "block.minecraft.redstone_block": "blokeng kulog",
  "block.minecraft.nether_quartz_ore": "mambatong impyer kuwarts",
  "block.minecraft.hopper": "lukton",
  "block.minecraft.chiseled_quartz_block": "pinaitang kuwartang bloke",
  "block.minecraft.quartz_block": "kuwartang bloke",
  "block.minecraft.quartz_bricks": "laryong kwarta",
  "block.minecraft.quartz_pillar": "haligi na kuwarts",
  "block.minecraft.quartz_stairs": "hagdanang kwarta",
  "block.minecraft.activator_rail": "andar-riles",
  "block.minecraft.dropper": "taga-hulog",
  "block.minecraft.white_terracotta": "puting terakota",
  "block.minecraft.orange_terracotta": "kahel na terakota",
  "block.minecraft.magenta_terracotta": "mahentang terakota",
  "block.minecraft.light_blue_terracotta": "langit na terakota",
  "block.minecraft.yellow_terracotta": "dilaw na terakota",
  "block.minecraft.lime_terracotta": "dayap na terakota",
  "block.minecraft.pink_terracotta": "rosas na terakota",
  "block.minecraft.gray_terracotta": "abong terakota",
  "block.minecraft.light_gray_terracotta": "pilak na terakota",
  "block.minecraft.cyan_terracotta": "cyan na terakota",
  "block.minecraft.purple_terracotta": "lilang terakota",
  "block.minecraft.blue_terracotta": "bughaw na terakota",
  "block.minecraft.brown_terracotta": "kayumangging terakota",
  "block.minecraft.green_terracotta": "luntiang terakota",
  "block.minecraft.red_terracotta": "pulang terakota",
  "block.minecraft.black_terracotta": "itim na terakota",
  "block.minecraft.barrier": "harang",
  "block.minecraft.iron_trapdoor": "bakal na pintong maliit",
  "block.minecraft.hay_block": "paldo ng dayami",
  "block.minecraft.white_carpet": "alpombrang puti",
  "block.minecraft.orange_carpet": "alpombrang dalandan",
  "block.minecraft.magenta_carpet": "mahentang alpombra",
  "block.minecraft.light_blue_carpet": "alpombrang langit",
  "block.minecraft.yellow_carpet": "alpombrang dilaw",
  "block.minecraft.lime_carpet": "alpombrang dayap",
  "block.minecraft.pink_carpet": "alpombrang rosas",
  "block.minecraft.gray_carpet": "alpombrang abo",
  "block.minecraft.light_gray_carpet": "alpombrang pilak",
  "block.minecraft.cyan_carpet": "alpombrang cyan",
  "block.minecraft.purple_carpet": "alpombrang lila",
  "block.minecraft.blue_carpet": "alpombrang bughaw",
  "block.minecraft.brown_carpet": "alpombrang kayumanggi",
  "block.minecraft.green_carpet": "alpombrang luntian",
  "block.minecraft.red_carpet": "alpombrang pula",
  "block.minecraft.black_carpet": "alpombrang itim",
  "block.minecraft.terracotta": "terakota",
  "block.minecraft.coal_block": "karbong bloke",
  "block.minecraft.packed_ice": "siniksik na yelo",
  "block.minecraft.acacia_stairs": "akasyang hagdanan",
  "block.minecraft.dark_oak_stairs": "maitim na robleng hagdanan",
  "block.minecraft.slime_block": "bloke ng lusak",
  "block.minecraft.grass_path": "damong landas",
  "block.minecraft.sunflower": "mirasol",
  "block.minecraft.lilac": "lila",
  "block.minecraft.rose_bush": "palumpong rosas",
  "block.minecraft.peony": "peoni",
  "block.minecraft.tall_grass": "mataas na damo",
  "block.minecraft.large_fern": "malaking eletso",
  "block.minecraft.white_stained_glass": "salaming puti",
  "block.minecraft.orange_stained_glass": "salaming kahel",
  "block.minecraft.magenta_stained_glass": "mahentang salamin",
  "block.minecraft.light_blue_stained_glass": "salaming mapusyaw na bughaw",
  "block.minecraft.yellow_stained_glass": "salaming dilaw",
  "block.minecraft.lime_stained_glass": "salaming dayap",
  "block.minecraft.pink_stained_glass": "salaming rosas",
  "block.minecraft.gray_stained_glass": "salaming abo",
  "block.minecraft.light_gray_stained_glass": "salaming pilak",
  "block.minecraft.cyan_stained_glass": "salaming cyan",
  "block.minecraft.purple_stained_glass": "salaming lila",
  "block.minecraft.blue_stained_glass": "salaming bughaw",
  "block.minecraft.brown_stained_glass": "salaming kayumanggi",
  "block.minecraft.green_stained_glass": "salaming luntian",
  "block.minecraft.red_stained_glass": "salaming pula",
  "block.minecraft.black_stained_glass": "salaming itim",
  "block.minecraft.white_stained_glass_pane": "bintanang puti",
  "block.minecraft.orange_stained_glass_pane": "bintanang kahel",
  "block.minecraft.magenta_stained_glass_pane": "mahentang bintana",
  "block.minecraft.light_blue_stained_glass_pane": "bintanang langit",
  "block.minecraft.yellow_stained_glass_pane": "bintanang dilaw",
  "block.minecraft.lime_stained_glass_pane": "bintanang dayap",
  "block.minecraft.pink_stained_glass_pane": "bintanang rosas",
  "block.minecraft.gray_stained_glass_pane": "bintanang abo",
  "block.minecraft.light_gray_stained_glass_pane": "bintanang pilak",
  "block.minecraft.cyan_stained_glass_pane": "bintanang cyan",
  "block.minecraft.purple_stained_glass_pane": "bintanang lila",
  "block.minecraft.blue_stained_glass_pane": "bintanang bughaw",
  "block.minecraft.brown_stained_glass_pane": "bintanang kayumanggi",
  "block.minecraft.green_stained_glass_pane": "bintanang luntian",
  "block.minecraft.red_stained_glass_pane": "bintanang pula",
  "block.minecraft.black_stained_glass_pane": "bintanang itim",
  "block.minecraft.prismarine": "prismarin",
  "block.minecraft.prismarine_bricks": "laryo ng prismarin",
  "block.minecraft.dark_prismarine": "maitim na prismarin",
  "block.minecraft.prismarine_stairs": "prismaring hagdanan",
  "block.minecraft.prismarine_brick_stairs": "laryo ng prismaring hagdanan",
  "block.minecraft.dark_prismarine_stairs": "maitim na prismaring hagdanan",
  "block.minecraft.sea_lantern": "lamparang dagat",
  "block.minecraft.red_sandstone": "mapulang batubuhangin",
  "block.minecraft.chiseled_red_sandstone": "mapulang buhang-pait",
  "block.minecraft.cut_red_sandstone": "ginupit na pulang sandstone",
  "block.minecraft.red_sandstone_stairs": "hagdanang pulang batubuhangin",
  "block.minecraft.repeating_command_block": "paulit-ulit na bloke ng utos",
  "block.minecraft.chain_command_block": "kadenang bloke ng utos",
  "block.minecraft.magma_block": "magmang bloke",
  "block.minecraft.nether_wart_block": "blokeng impyer butig",
  "block.minecraft.warped_wart_block": "nakiwal na butig na bloke",
  "block.minecraft.red_nether_bricks": "pulang impyer laryo",
  "block.minecraft.bone_block": "butong bloke",
  "block.minecraft.structure_void": "kawalan ng gusali",
  "block.minecraft.observer": "tagamasid",
  "block.minecraft.shulker_box": "kahon ng shulker",
  "block.minecraft.white_shulker_box": "puting kahon ng shulker",
  "block.minecraft.orange_shulker_box": "kahel na kahon ng shulker",
  "block.minecraft.magenta_shulker_box": "mahentang kahon ng shulker",
  "block.minecraft.light_blue_shulker_box": "langit na kahon ng shulker",
  "block.minecraft.yellow_shulker_box": "dilaw na kahon ng shulker",
  "block.minecraft.lime_shulker_box": "dayap na kahon ng shulker",
  "block.minecraft.pink_shulker_box": "rosas na kahon ng shulker",
  "block.minecraft.gray_shulker_box": "abong kahon ng shulker",
  "block.minecraft.light_gray_shulker_box": "pilak na kahon ng shulker",
  "block.minecraft.cyan_shulker_box": "cyan na kahon ng shulker",
  "block.minecraft.purple_shulker_box": "lilang kahon ng shulker",
  "block.minecraft.blue_shulker_box": "bughaw na kahon ng shulker",
  "block.minecraft.brown_shulker_box": "kayumangging kahon ng shulker",
  "block.minecraft.green_shulker_box": "luntiang kahon ng shulker",
  "block.minecraft.red_shulker_box": "pulang kahon ng shulker",
  "block.minecraft.black_shulker_box": "itim na kahon ng shulker",
  "block.minecraft.white_glazed_terracotta": "puting terakotang makintab",
  "block.minecraft.orange_glazed_terracotta": "kahel na terakotang makintab",
  "block.minecraft.magenta_glazed_terracotta": "mahentang terakotang makintab",
  "block.minecraft.light_blue_glazed_terracotta": "langit na terakotang makintab",
  "block.minecraft.yellow_glazed_terracotta": "dilaw na terakotang makintab",
  "block.minecraft.lime_glazed_terracotta": "dayap na terakotang makintab",
  "block.minecraft.pink_glazed_terracotta": "rosas na terakotang makintab",
  "block.minecraft.gray_glazed_terracotta": "abong terakotang makintab",
  "block.minecraft.light_gray_glazed_terracotta": "pilak na terakotang makintab",
  "block.minecraft.cyan_glazed_terracotta": "cyan na terakotang makintab",
  "block.minecraft.purple_glazed_terracotta": "lilang terakotang makintab",
  "block.minecraft.blue_glazed_terracotta": "bughaw na terakotang makintab",
  "block.minecraft.brown_glazed_terracotta": "kayumangging terakotang makintab",
  "block.minecraft.green_glazed_terracotta": "luntiang terakotang makintab",
  "block.minecraft.red_glazed_terracotta": "pulang terakotang makintab",
  "block.minecraft.black_glazed_terracotta": "itim na terakotang makintab",
  "block.minecraft.white_concrete": "puting kongkreto",
  "block.minecraft.orange_concrete": "kahel na kongkreto",
  "block.minecraft.magenta_concrete": "mahentang kongkreto",
  "block.minecraft.light_blue_concrete": "langit na kongkreto",
  "block.minecraft.yellow_concrete": "dilaw na kongkreto",
  "block.minecraft.lime_concrete": "dayap na kongkreto",
  "block.minecraft.pink_concrete": "rosas na kongkreto",
  "block.minecraft.gray_concrete": "abong kongkreto",
  "block.minecraft.light_gray_concrete": "pilak na kongkreto",
  "block.minecraft.cyan_concrete": "cyan na kongkreto",
  "block.minecraft.purple_concrete": "lilang kongkreto",
  "block.minecraft.blue_concrete": "bughaw na kongkreto",
  "block.minecraft.brown_concrete": "kayumangging kongkreto",
  "block.minecraft.green_concrete": "luntiang kongkreto",
  "block.minecraft.red_concrete": "pulang kongkreto",
  "block.minecraft.black_concrete": "itim na kongkreto",
  "block.minecraft.white_concrete_powder": "puting pulbos ng kongkreto",
  "block.minecraft.orange_concrete_powder": "kahel na pulbos ng kongkreto",
  "block.minecraft.magenta_concrete_powder": "mahentang pulbos ng kongkreto",
  "block.minecraft.light_blue_concrete_powder": "langit na pulbos ng kongkreto",
  "block.minecraft.yellow_concrete_powder": "dilaw na pulbos ng kongkreto",
  "block.minecraft.lime_concrete_powder": "dayap na pulbos ng kongkreto",
  "block.minecraft.pink_concrete_powder": "rosas na pulbos ng kongkreto",
  "block.minecraft.gray_concrete_powder": "abong pulbos ng kongkreto",
  "block.minecraft.light_gray_concrete_powder": "pilak na pulbos ng kongkreto",
  "block.minecraft.cyan_concrete_powder": "cyan na pulbos ng kongkreto",
  "block.minecraft.purple_concrete_powder": "lilang pulbos ng kongkreto",
  "block.minecraft.blue_concrete_powder": "bughaw na pulbos ng kongkreto",
  "block.minecraft.brown_concrete_powder": "kayumangging pulbos ng kongkreto",
  "block.minecraft.green_concrete_powder": "luntiang pulbos ng kongkreto",
  "block.minecraft.red_concrete_powder": "pulang pulbos ng kongkreto",
  "block.minecraft.black_concrete_powder": "itim na pulbos ng kongkreto",
  "block.minecraft.turtle_egg": "itlog ng pagong",
  "block.minecraft.dead_tube_coral_block": "patay na bloke ng bughaw na koral",
  "block.minecraft.dead_brain_coral_block": "patay na bloke ng kulay rosas na koral",
  "block.minecraft.dead_bubble_coral_block": "patay na bloke ng lilang koral",
  "block.minecraft.dead_fire_coral_block": "patay na bloke ng pulang koral",
  "block.minecraft.dead_horn_coral_block": "patay na bloke ng dilaw na koral",
  "block.minecraft.tube_coral_block": "bloke ng bughaw na koral",
  "block.minecraft.brain_coral_block": "bloke ng kulay rosas na koral",
  "block.minecraft.bubble_coral_block": "bloke ng lilang koral",
  "block.minecraft.fire_coral_block": "bloke ng pulang koral",
  "block.minecraft.horn_coral_block": "bloke ng dilaw na koral",
  "block.minecraft.tube_coral": "bughaw na koral",
  "block.minecraft.brain_coral": "kulay rosas na koral",
  "block.minecraft.bubble_coral": "lilang koral",
  "block.minecraft.fire_coral": "pulang koral",
  "block.minecraft.horn_coral": "dilaw na koral",
  "block.minecraft.dead_brain_coral": "patay na kulay rosas na koral",
  "block.minecraft.dead_bubble_coral": "patay na lilang koral",
  "block.minecraft.dead_fire_coral": "patay na pulang koral",
  "block.minecraft.dead_horn_coral": "patay na dilaw na koral",
  "block.minecraft.dead_tube_coral": "patay na bughaw na koral",
  "block.minecraft.tube_coral_fan": "bughaw na pamaypay ng koral",
  "block.minecraft.brain_coral_fan": "kulay rosas na pamaypay ng koral",
  "block.minecraft.bubble_coral_fan": "lilang pamaypay ng koral",
  "block.minecraft.fire_coral_fan": "pulang pamaypay ng koral",
  "block.minecraft.horn_coral_fan": "dilaw na pamaypay ng koral",
  "block.minecraft.dead_tube_coral_fan": "patay na pamaypay ng bughaw na koral",
  "block.minecraft.dead_brain_coral_fan": "patay na pamaypay ng kulay rosas na koral",
  "block.minecraft.dead_bubble_coral_fan": "patay na pamaypay ng lilang koral",
  "block.minecraft.dead_fire_coral_fan": "patay na pamaypay ng pulang koral",
  "block.minecraft.dead_horn_coral_fan": "patay na pamaypay ng dilaw na koral",
  "block.minecraft.blue_ice": "bughaw na yelo",
  "block.minecraft.conduit": "daluyan",
  "block.minecraft.polished_granite_stairs": "makinis na granayt na hagdanan",
  "block.minecraft.smooth_red_sandstone_stairs": "pulang buhang-buling hagdanan",
  "block.minecraft.mossy_stone_brick_stairs": "laryong lumot na hagdanan",
  "block.minecraft.polished_diorite_stairs": "makinis na diyorayt na hagdanan",
  "block.minecraft.mossy_cobblestone_stairs": "malumot byakbatong hagdan",
  "block.minecraft.end_stone_brick_stairs": "end na batong hagdanan",
  "block.minecraft.stone_stairs": "batong hagdanan",
  "block.minecraft.smooth_sandstone_stairs": "buhang-buling hagdanan",
  "block.minecraft.smooth_quartz_stairs": "makinis na kuwartang hagdanan",
  "block.minecraft.granite_stairs": "granayt na hagdanan",
  "block.minecraft.andesite_stairs": "andesayt na hagdanan",
  "block.minecraft.red_nether_brick_stairs": "pulang impyer laryong hagdan",
  "block.minecraft.polished_andesite_stairs": "makinis na andesayt na hagdanan",
  "block.minecraft.diorite_stairs": "diyorayt na hagdanan",
  "block.minecraft.polished_granite_slab": "pinakintab na granayt na tilad",
  "block.minecraft.smooth_red_sandstone_slab": "mapulang buhang-buling tilad",
  "block.minecraft.mossy_stone_brick_slab": "laryong lumot na tilad",
  "block.minecraft.polished_diorite_slab": "makinis na diyorayt na tilad",
  "block.minecraft.mossy_cobblestone_slab": "malumot byakbatong tilad",
  "block.minecraft.end_stone_brick_slab": "end na laryong batong tilad",
  "block.minecraft.smooth_sandstone_slab": "buhang-buling tilad",
  "block.minecraft.smooth_quartz_slab": "makinis na kuwartang tilad",
  "block.minecraft.granite_slab": "granayt na tilad",
  "block.minecraft.andesite_slab": "andesayt na tilad",
  "block.minecraft.red_nether_brick_slab": "pulang laryong laryong tilad",
  "block.minecraft.polished_andesite_slab": "makinis na andesayt na tilad",
  "block.minecraft.diorite_slab": "diyorayt na tilad",
  "block.minecraft.scaffolding": "patungan",
  "block.minecraft.iron_door": "pintuang bakal",
  "block.minecraft.oak_door": "robleng pinto",
  "block.minecraft.spruce_door": "pinong pinto",
  "block.minecraft.birch_door": "birkeng pinto",
  "block.minecraft.jungle_door": "gubat na pinto",
  "block.minecraft.acacia_door": "akasyang pinto",
  "block.minecraft.dark_oak_door": "madilim na robleng pinto",
  "block.minecraft.crimson_door": "krimsong pinto",
  "block.minecraft.warped_door": "nakiwal na pinto",
  "block.minecraft.repeater": "redstone repeater",
  "block.minecraft.comparator": "kulog panakwil",
  "block.minecraft.structure_block": "bloke ng gusali",
  "block.minecraft.jigsaw": "palaisipang bloke",
  "item.minecraft.turtle_helmet": "talukab ng pagong□□kung nasa ulo:□+2 baluti",
  "item.minecraft.scute": "piraso ng talukab ng pagong",
  "item.minecraft.iron_shovel": "palang bakal□□kung nasa pangunahing kamay:□+3.5 lakas ng atake□-3 bilis ng atake",
  "item.minecraft.iron_pickaxe": "pikong bakal□□kung nasa pangunahing kamay:□+3 lakas ng atake□-2.8 bilis ng atake",
  "item.minecraft.iron_axe": "palakong bakal□□kung nasa pangunahing kamay:□+8 lakas ng atake□-3.1 bilis ng atake",
  "item.minecraft.flint_and_steel": "sindihan",
  "item.minecraft.apple": "mansanas",
  "item.minecraft.bow": "pana",
  "item.minecraft.arrow": "tunod",
  "item.minecraft.coal": "karbon",
  "item.minecraft.charcoal": "uling",
  "item.minecraft.diamond": "brilyante",
  "item.minecraft.iron_ingot": "bakal",
  "item.minecraft.gold_ingot": "ginto",
  "item.minecraft.netherite_ingot": "impyer yaman",
  "item.minecraft.netherite_scrap": "tipak ng impyer yaman",
  "item.minecraft.iron_sword": "espadang bakal□□kung nasa pangunahing kamay:□+5 lakas ng atake□-2.4 bilis ng atake",
  "item.minecraft.wooden_sword": "espadang kahoy□□kung nasa pangunahing kamay:□+3 lakas ng atake□-2.4 bilis ng atake",
  "item.minecraft.wooden_shovel": "palang kahoy□□kung nasa pangunahing kamay:□+1.5 lakas ng atake□-3 bilis ng atake",
  "item.minecraft.wooden_pickaxe": "pikong kahoy□□kung nasa pangunahing kamay:□+1 lakas ng atake□-2.8 bilis ng atake",
  "item.minecraft.wooden_axe": "palakong kahoy□□kung nasa pangunahing kamay:□+6 lakas ng atake□-3.2 bilis ng atake",
  "item.minecraft.stone_sword": "espadang bato□□kung nasa pangunahing kamay:□+4 lakas ng atake□-2.4 bilis ng atake",
  "item.minecraft.stone_shovel": "palang bato□□kung nasa pangunahing kamay:□+2.5 lakas ng atake□-3 bilis ng atake",
  "item.minecraft.stone_pickaxe": "pikong bato□□kung nasa pangunahing kamay:□+2 lakas ng atake□-2.8 bilis ng atake",
  "item.minecraft.stone_axe": "palakong bato□□kung nasa pangunahing kamay:□+8 lakas ng atake□-3.2 bilis ng atake",
  "item.minecraft.diamond_sword": "espadang brilyante□□kung nasa pangunahing kamay:□+6 lakas ng atake□-2.4 bilis ng atake",
  "item.minecraft.diamond_shovel": "palang brilyante□□kung nasa pangunahing kamay:□+4.5 lakas ng atake□-3 bilis ng atake",
  "item.minecraft.diamond_pickaxe": "pikong brilyante□□kung nasa pangunahing kamay:□+4 lakas ng atake□-2.8 bilis ng atake",
  "item.minecraft.diamond_axe": "palakong brilyante□□kung nasa pangunahing kamay:□+8 lakas ng atake□-3 bilis ng atake",
  "item.minecraft.stick": "tunkod",
  "item.minecraft.bowl": "mangkok",
  "item.minecraft.mushroom_stew": "nilagang kabuti",
  "item.minecraft.golden_sword": "espadang ginto□□kung nasa pangunahing kamay:□+3 lakas ng atake□-2.4 bilis ng atake",
  "item.minecraft.golden_shovel": "palang ginto□□kung nasa pangunahing kamay:□+1.5 lakas ng atake□-3 bilis ng atake",
  "item.minecraft.golden_pickaxe": "pikong ginto□□kung nasa pangunahing kamay:□+1 lakas ng atake□-2.8 bilis ng atake",
  "item.minecraft.golden_axe": "palakong ginto□□kung nasa pangunahing kamay:□+6 lakas ng atake□-3 bilis ng atake",
  "item.minecraft.netherite_sword": "impyer espada□□kung nasa pangunahing kamay:□+7 lakas ng atake□-2.4 bilis ng atake",
  "item.minecraft.netherite_shovel": "impyer pala□□kung nasa pangunahing kamay:□+5.5 lakas ng atake□-3 bilis ng atake",
  "item.minecraft.netherite_pickaxe": "impyer piko□□kung nasa pangunahing kamay:□+5 lakas ng atake□-2.8 bilis ng atake",
  "item.minecraft.netherite_axe": "impyer palakol□□kung nasa pangunahing kamay:□+9 lakas ng atake□-3 bilis ng atake",
  "item.minecraft.string": "tali",
  "item.minecraft.feather": "balahibo",
  "item.minecraft.gunpowder": "pulbura",
  "item.minecraft.wooden_hoe": "asadang kahoy□□kung nasa pangunahing kamay:□-3 bilis ng atake",
  "item.minecraft.stone_hoe": "asadang bato□□kung nasa pangunahing kamay:□-2 bilis ng atake",
  "item.minecraft.iron_hoe": "asadang bakal□□kung nasa pangunahing kamay:□-1 bilis ng atake",
  "item.minecraft.diamond_hoe": "asadang brilyante□□kung nasa pangunahing kamay:",
  "item.minecraft.golden_hoe": "asadang ginto□□kung nasa pangunahing kamay:□-3 bilis ng atake",
  "item.minecraft.netherite_hoe": "impyer asada□□kung nasa pangunahing kamay:",
  "item.minecraft.wheat_seeds": "trigong punla",
  "item.minecraft.wheat": "trigo",
  "item.minecraft.bread": "tinapay",
  "item.minecraft.leather_helmet": "capang katad□□kung nasa ulo:□+1 baluti",
  "item.minecraft.leather_chestplate": "tunikang katad□□kung nasa katawan:□+3 baluti",
  "item.minecraft.leather_leggings": "pantalong katad□□kung nasa binti:□+2 baluti",
  "item.minecraft.leather_boots": "botang katad□□kung nasa paa:□+1 baluti",
  "item.minecraft.chainmail_helmet": "kupyang tanikala□□kung nasa ulo:□+2 baluti",
  "item.minecraft.chainmail_chestplate": "baluting tanikala□□kung nasa katawan:□+5 baluti",
  "item.minecraft.chainmail_leggings": "pulinasang tanikala□□kung nasa binti:□+4 baluti",
  "item.minecraft.chainmail_boots": "botang tanikala□□kung nasa paa:□+1 baluti",
  "item.minecraft.iron_helmet": "kupyang bakal□□kung nasa ulo:□+2 baluti",
  "item.minecraft.iron_chestplate": "baluting bakal□□kung nasa katawan:□+6 baluti",
  "item.minecraft.iron_leggings": "pulinasang bakal□□kung nasa binti:□+5 baluti",
  "item.minecraft.iron_boots": "botang bakal□□kung nasa paa:□+2 baluti",
  "item.minecraft.diamond_helmet": "kupyang brilyante□□kung nasa ulo:□+3 baluti□+2 lakas ng baluti",
  "item.minecraft.diamond_chestplate": "baluting brilyante□□kung nasa katawan:□+8 baluti□+2 lakas ng baluti",
  "item.minecraft.diamond_leggings": "pulinasang brilyante□□kung nasa binti:□+6 baluti□+2 lakas ng baluti",
  "item.minecraft.diamond_boots": "botang brilyante□□kung nasa paa:□+3 baluti□+2 lakas ng baluti",
  "item.minecraft.golden_helmet": "kupyang ginto□□kung nasa ulo:□+2 baluti",
  "item.minecraft.golden_chestplate": "baluting ginto□□kung nasa katawan:□+5 baluti",
  "item.minecraft.golden_leggings": "pulinasang ginto□□kung nasa binti:□+3 baluti",
  "item.minecraft.golden_boots": "botang ginto□□kung nasa paa:□+1 baluti",
  "item.minecraft.netherite_helmet": "impyer helmet□□kung nasa ulo:□+3 baluti□+3 lakas ng baluti□+1 paglaban sa tulak",
  "item.minecraft.netherite_chestplate": "impyer kasuotan□□kung nasa katawan:□+8 baluti□+3 lakas ng baluti□+1 paglaban sa tulak",
  "item.minecraft.netherite_leggings": "impyer pulinas□□kung nasa binti:□+6 baluti□+3 lakas ng baluti□+1 paglaban sa tulak",
  "item.minecraft.netherite_boots": "impyer botas□□kung nasa paa:□+3 baluti□+3 lakas ng baluti□+1 paglaban sa tulak",
  "item.minecraft.flint": "puyusan",
  "item.minecraft.porkchop": "hilaw na porkchop",
  "item.minecraft.cooked_porkchop": "lutong porkchop",
  "item.minecraft.painting": "larawan",
  "item.minecraft.golden_apple": "gintong mansanas",
  "item.minecraft.enchanted_golden_apple": "marahuyong gintong mansanas",
  "block.minecraft.oak_sign": "robleng karatula",
  "block.minecraft.spruce_sign": "pinong karatula",
  "block.minecraft.birch_sign": "birkeng karatula",
  "block.minecraft.jungle_sign": "gubat na karatula",
  "block.minecraft.acacia_sign": "akasyang karatula",
  "block.minecraft.dark_oak_sign": "maitim na robleng karatula",
  "block.minecraft.crimson_sign": "krimsong karatula",
  "block.minecraft.warped_sign": "nakiwal na karatula",
  "item.minecraft.bucket": "balde",
  "item.minecraft.water_bucket": "balde ng tubig",
  "item.minecraft.lava_bucket": "balde ng kumukulong putik",
  "item.minecraft.minecart": "karitela",
  "item.minecraft.saddle": "sintadera",
  "item.minecraft.redstone": "kulog pulbo",
  "item.minecraft.snowball": "bola ng niyebe",
  "item.minecraft.oak_boat": "robleng bangka",
  "item.minecraft.leather": "katad",
  "item.minecraft.milk_bucket": "balde ng gatas",
  "item.minecraft.pufferfish_bucket": "balde ng pufferfish",
  "item.minecraft.salmon_bucket": "balde ng salmon",
  "item.minecraft.cod_bucket": "balde ng bakalaw",
  "item.minecraft.tropical_fish_bucket": "balde ng isdang tropikal",
  "item.minecraft.brick": "ladrilyo",
  "item.minecraft.clay_ball": "bola ng luwad",
  "block.minecraft.dried_kelp_block": "tuyong bloke ng kelp",
  "item.minecraft.paper": "papel",
  "item.minecraft.book": "aklat",
  "item.minecraft.slime_ball": "bola ng lusak",
  "item.minecraft.chest_minecart": "karitelang baul",
  "item.minecraft.furnace_minecart": "karitelang pugon",
  "item.minecraft.egg": "itlog",
  "item.minecraft.compass": "bruhula",
  "item.minecraft.fishing_rod": "pamingwit",
  "item.minecraft.clock": "orasan",
  "item.minecraft.glowstone_dust": "sindin-abo",
  "item.minecraft.cod": "hilaw na bakalaw",
  "item.minecraft.salmon": "hilaw na salmon",
  "item.minecraft.tropical_fish": "isdang tropikal",
  "item.minecraft.pufferfish": "pufferfish",
  "item.minecraft.cooked_cod": "luto na bakalaw",
  "item.minecraft.cooked_salmon": "lutong salmon",
  "item.minecraft.ink_sac": "tinta",
  "item.minecraft.red_dye": "tintang pula",
  "item.minecraft.green_dye": "tintang luntian",
  "item.minecraft.cocoa_beans": "kakaw",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "tintang lila",
  "item.minecraft.cyan_dye": "tintang cyan",
  "item.minecraft.light_gray_dye": "tintang pilak",
  "item.minecraft.gray_dye": "tintang abo",
  "item.minecraft.pink_dye": "tintang rosas",
  "item.minecraft.lime_dye": "tintang dayap",
  "item.minecraft.yellow_dye": "tintang dilaw",
  "item.minecraft.light_blue_dye": "tintang langit",
  "item.minecraft.magenta_dye": "tintang mahenta",
  "item.minecraft.orange_dye": "tintang kahel",
  "item.minecraft.bone_meal": "kainang buto",
  "item.minecraft.blue_dye": "tintang bughaw",
  "item.minecraft.brown_dye": "tintang kayumanggi",
  "item.minecraft.black_dye": "tintang itim",
  "item.minecraft.white_dye": "tintang puti",
  "item.minecraft.bone": "buto",
  "item.minecraft.sugar": "asukal",
  "block.minecraft.cake": "keyk",
  "block.minecraft.white_bed": "puting kama",
  "block.minecraft.orange_bed": "kahel na kama",
  "block.minecraft.magenta_bed": "mahentang kama",
  "block.minecraft.light_blue_bed": "langit na kama",
  "block.minecraft.yellow_bed": "dilaw na kama",
  "block.minecraft.lime_bed": "dayap na kama",
  "block.minecraft.pink_bed": "rosas na kama",
  "block.minecraft.gray_bed": "abong kama",
  "block.minecraft.light_gray_bed": "pilak na kama",
  "block.minecraft.cyan_bed": "cyan na kama",
  "block.minecraft.purple_bed": "lilang kama",
  "block.minecraft.blue_bed": "bughaw na kama",
  "block.minecraft.brown_bed": "kayumangging kama",
  "block.minecraft.green_bed": "luntiang kama",
  "block.minecraft.red_bed": "pulang kama",
  "block.minecraft.black_bed": "itim na kama",
  "item.minecraft.cookie": "galyetas",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "gunting",
  "item.minecraft.melon_slice": "hiwa ng pakwan",
  "item.minecraft.dried_kelp": "pinatuyong kelp",
  "item.minecraft.pumpkin_seeds": "punlang kalabasa",
  "item.minecraft.melon_seeds": "punlang melon",
  "item.minecraft.beef": "hilaw na karneng baka",
  "item.minecraft.cooked_beef": "lutong karneng baka",
  "item.minecraft.chicken": "hilaw na manok",
  "item.minecraft.cooked_chicken": "lutong manok",
  "item.minecraft.rotten_flesh": "bulok na laman",
  "item.minecraft.ender_pearl": "perlas na ender",
  "item.minecraft.blaze_rod": "liyabaras",
  "item.minecraft.ghast_tear": "luha ng ghast",
  "item.minecraft.gold_nugget": "pirasong ginto",
  "item.minecraft.nether_wart": "impyer butig",
  "item.minecraft.potion": "gayumang di-magawa□walang epekto",
  "item.minecraft.glass_bottle": "salaming bote",
  "item.minecraft.spider_eye": "mata ng gagamba",
  "item.minecraft.fermented_spider_eye": "tinimplang mata ng gagamba",
  "item.minecraft.blaze_powder": "liyabo",
  "item.minecraft.magma_cream": "magmakatas",
  "block.minecraft.brewing_stand": "kuluan",
  "block.minecraft.cauldron": "kaldero",
  "item.minecraft.ender_eye": "mata ng wakas",
  "item.minecraft.glistering_melon_slice": "linang hiwa ng pakwan",
  "item.minecraft.bat_spawn_egg": "panlikhaang itlog ng paniki",
  "item.minecraft.bee_spawn_egg": "panlikhaang itlog ng bubuyog",
  "item.minecraft.blaze_spawn_egg": "panlikhaang itlog ng liyab",
  "item.minecraft.cat_spawn_egg": "panlikhaang itlog ng pusa",
  "item.minecraft.cave_spider_spawn_egg": "panlikhaang itlog ng gagambang-kuweba",
  "item.minecraft.chicken_spawn_egg": "panlikhaang itlog ng manok",
  "item.minecraft.cod_spawn_egg": "panlikhaang itlog ng bakalaw",
  "item.minecraft.cow_spawn_egg": "panlikhaang itlog ng baka",
  "item.minecraft.creeper_spawn_egg": "panlikhaang itlog ng kilabot",
  "item.minecraft.dolphin_spawn_egg": "panlikhaang itlog ng dolpin",
  "item.minecraft.donkey_spawn_egg": "panlikhaang itlog ng asno",
  "item.minecraft.drowned_spawn_egg": "panlikhaang itlog ng nangalunod",
  "item.minecraft.elder_guardian_spawn_egg": "panlikhaang itlog ng matandang tagabantay",
  "item.minecraft.enderman_spawn_egg": "panlikhaang itlog ng enderman",
  "item.minecraft.endermite_spawn_egg": "panlikhaang itlog ng endermite",
  "item.minecraft.evoker_spawn_egg": "panlikhaang itlog ng evoker",
  "item.minecraft.fox_spawn_egg": "panlikhaang itlog ng soro",
  "item.minecraft.ghast_spawn_egg": "panlikhaang itlog ng ghast",
  "item.minecraft.guardian_spawn_egg": "panlikhaang itlog ng tagabantay",
  "item.minecraft.hoglin_spawn_egg": "itlog ng hoglin",
  "item.minecraft.horse_spawn_egg": "panlikhaang itlog ng kabayo",
  "item.minecraft.husk_spawn_egg": "panlikhaang itlog ng huska",
  "item.minecraft.llama_spawn_egg": "panlikhaang itlog ng liyama",
  "item.minecraft.magma_cube_spawn_egg": "panlikhaang itlog ng kubong magma",
  "item.minecraft.mooshroom_spawn_egg": "panlikhaang itlog ng bakabute",
  "item.minecraft.mule_spawn_egg": "panlikhaang itlog ng mola",
  "item.minecraft.ocelot_spawn_egg": "panlikhaang itlog ng oselot",
  "item.minecraft.panda_spawn_egg": "panlikhaang itlog ng panda",
  "item.minecraft.parrot_spawn_egg": "panlikhaang itlog ng loro",
  "item.minecraft.phantom_spawn_egg": "panlikhaang itlog ng multo",
  "item.minecraft.pig_spawn_egg": "panlikhaang itlog ng baboy",
  "item.minecraft.piglin_spawn_egg": "itlog ng piglin",
  "item.minecraft.pillager_spawn_egg": "panlikhaang itlog ng mandarambong",
  "item.minecraft.polar_bear_spawn_egg": "panlikhaang itlog ng osong puti",
  "item.minecraft.pufferfish_spawn_egg": "panlikhaang itlog ng pufferfish",
  "item.minecraft.rabbit_spawn_egg": "panlikhaang itlog ng kuneho",
  "item.minecraft.ravager_spawn_egg": "panlikhaang itlog ng ravager",
  "item.minecraft.salmon_spawn_egg": "panlikhaang itlog ng salmon",
  "item.minecraft.sheep_spawn_egg": "panlikhaang itlog ng tupa",
  "item.minecraft.shulker_spawn_egg": "panlikhaang itlog ng shulker",
  "item.minecraft.silverfish_spawn_egg": "panlikhaang itlog ng pilakam-uod",
  "item.minecraft.skeleton_spawn_egg": "panlikhaang itlog ng kalansay",
  "item.minecraft.skeleton_horse_spawn_egg": "panlikhaang itlog ng kabayong kalansay",
  "item.minecraft.slime_spawn_egg": "panlikhaang itlog ng lusak",
  "item.minecraft.spider_spawn_egg": "panlikhaang itlog ng gagamba",
  "item.minecraft.squid_spawn_egg": "panlikhaang itlog ng pusit",
  "item.minecraft.stray_spawn_egg": "panlikhaang itlog ng ligaw",
  "item.minecraft.strider_spawn_egg": "panlikhaang itlog ng strider",
  "item.minecraft.trader_llama_spawn_egg": "panlikhaang itlog ng liyama ng mangangalakal",
  "item.minecraft.tropical_fish_spawn_egg": "panlikhaang itlog ng tropikal na isda",
  "item.minecraft.turtle_spawn_egg": "panlikhaang itlog ng pagong",
  "item.minecraft.vex_spawn_egg": "panlikhaang itlog ng gugulo",
  "item.minecraft.villager_spawn_egg": "panlikhaang itlog ng taganayon",
  "item.minecraft.vindicator_spawn_egg": "panlikhaang itlog ng tagapagtanggol",
  "item.minecraft.wandering_trader_spawn_egg": "panlikhaang itlog ng naglalakbayang mangangalakal",
  "item.minecraft.witch_spawn_egg": "panlikhaang itlog ng mangkukulam",
  "item.minecraft.wither_skeleton_spawn_egg": "panlikhaang itlog ng wither na kalansay",
  "item.minecraft.wolf_spawn_egg": "panlikhaang itlog ng lobo",
  "item.minecraft.zoglin_spawn_egg": "panlikhaang itlog ng zoglin",
  "item.minecraft.zombie_spawn_egg": "panlikhaang itlog ng sombi",
  "item.minecraft.zombie_horse_spawn_egg": "panlikhaang itlog ng kabayong sombi",
  "item.minecraft.zombie_villager_spawn_egg": "panlikhaang itlog ng sombing taganayon",
  "item.minecraft.zombified_piglin_spawn_egg": "panlikhaang itlog ng zombing piglin",
  "item.minecraft.experience_bottle": "bote ng pagrarahuyo",
  "item.minecraft.fire_charge": "karga ng apoy",
  "item.minecraft.writable_book": "aklat at pluma",
  "item.minecraft.written_book": "sinulatang aklat",
  "item.minecraft.emerald": "esmeralda",
  "item.minecraft.item_frame": "kuwardo",
  "block.minecraft.flower_pot": "paso",
  "item.minecraft.carrot": "karot",
  "item.minecraft.potato": "patatas",
  "item.minecraft.baked_potato": "lutong patatas",
  "item.minecraft.poisonous_potato": "nakakalasong patatas",
  "item.minecraft.map": "blankong mapa",
  "item.minecraft.golden_carrot": "gintong karot",
  "block.minecraft.skeleton_skull": "bungo ng kalansay",
  "block.minecraft.wither_skeleton_skull": "bungo ng wither na kalansay",
  "block.minecraft.player_head": "ulo ng manlalaro",
  "block.minecraft.zombie_head": "bungo ng zombi",
  "block.minecraft.creeper_head": "ulo ng kilabot",
  "block.minecraft.dragon_head": "ulo ng dragon",
  "item.minecraft.carrot_on_a_stick": "karot sa tunkod",
  "item.minecraft.warped_fungus_on_a_stick": "kabuting-kiwal sa isang tunkod",
  "item.minecraft.nether_star": "impyerituin",
  "item.minecraft.pumpkin_pie": "pastel na kalabasa",
  "item.minecraft.firework_rocket": "raketa ng paputok",
  "item.minecraft.firework_star": "bituin ng paputok",
  "item.minecraft.enchanted_book": "libro ng pagrarahuyo",
  "item.minecraft.nether_brick": "impyer laryo",
  "item.minecraft.quartz": "impyer kuwarts",
  "item.minecraft.tnt_minecart": "karitelang bomba",
  "item.minecraft.hopper_minecart": "karitelang lukton",
  "item.minecraft.prismarine_shard": "shard ng prismarin",
  "item.minecraft.prismarine_crystals": "mga kristal ng prismarin",
  "item.minecraft.rabbit": "hilaw na karne ng kuneho",
  "item.minecraft.cooked_rabbit": "lutong karne ng kuneho",
  "item.minecraft.rabbit_stew": "nilagang kuneho",
  "item.minecraft.rabbit_foot": "paa ng kuneho",
  "item.minecraft.rabbit_hide": "tago ng kuneho",
  "item.minecraft.armor_stand": "sabitan ng baluti",
  "item.minecraft.iron_horse_armor": "pangkabayong baluting bakal",
  "item.minecraft.golden_horse_armor": "pangkabayong baluting ginto",
  "item.minecraft.diamond_horse_armor": "pangkabayong baluting brilyante",
  "item.minecraft.leather_horse_armor": "pangkabayong baluting katad",
  "item.minecraft.lead": "panali",
  "item.minecraft.name_tag": "panandang pangalan",
  "item.minecraft.command_block_minecart": "karitelang bloke ng utos",
  "item.minecraft.mutton": "hilaw na karne ng tupa",
  "item.minecraft.cooked_mutton": "lutong karne ng tupa",
  "block.minecraft.white_banner": "puting watawat",
  "block.minecraft.orange_banner": "kahel na watawat",
  "block.minecraft.magenta_banner": "mahentang watawat",
  "block.minecraft.light_blue_banner": "langit na watawat",
  "block.minecraft.yellow_banner": "dilaw na watawat",
  "block.minecraft.lime_banner": "dayap na watawat",
  "block.minecraft.pink_banner": "rosas na watawat",
  "block.minecraft.gray_banner": "abong watawat",
  "block.minecraft.light_gray_banner": "pilak na watawat",
  "block.minecraft.cyan_banner": "cyan na watawat",
  "block.minecraft.purple_banner": "lilang watawat",
  "block.minecraft.blue_banner": "bughaw na watawat",
  "block.minecraft.brown_banner": "kayumangging watawat",
  "block.minecraft.green_banner": "luntiang watawat",
  "block.minecraft.red_banner": "pulang watawat",
  "block.minecraft.black_banner": "itim na watawat",
  "item.minecraft.end_crystal": "end na kristal",
  "item.minecraft.chorus_fruit": "korong prutas",
  "item.minecraft.popped_chorus_fruit": "binusang korong prutas",
  "item.minecraft.beetroot": "beetroot",
  "item.minecraft.beetroot_seeds": "punla ng beetroot",
  "item.minecraft.beetroot_soup": "sabaw ng beetroot",
  "item.minecraft.dragon_breath": "hininga ng dragon",
  "item.minecraft.splash_potion": "hinahagis na gayumang di-magawa□walang epekto",
  "item.minecraft.spectral_arrow": "multong tunod",
  "item.minecraft.tipped_arrow": "di-magawang hinawakang tunod□walang epekto",
  "item.minecraft.lingering_potion": "tumatagal na gayumang di-magawa□walang epekto",
  "item.minecraft.shield": "panangga",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "pinong bangka",
  "item.minecraft.birch_boat": "birkeng bangka",
  "item.minecraft.jungle_boat": "gubat na bangka",
  "item.minecraft.acacia_boat": "akasyang bangka",
  "item.minecraft.dark_oak_boat": "maitim na robleng bangka",
  "item.minecraft.totem_of_undying": "agimat ng walang kamatayan",
  "item.minecraft.shulker_shell": "kabibi ng shulker",
  "item.minecraft.iron_nugget": "pirasong bakal",
  "item.minecraft.knowledge_book": "kaalamang aklat",
  "item.minecraft.debug_stick": "tungkod ng debug",
  "item.minecraft.music_disc_13": "album□c418 - 13",
  "item.minecraft.music_disc_cat": "album□c418 - cat",
  "item.minecraft.music_disc_blocks": "album□c418 - blocks",
  "item.minecraft.music_disc_chirp": "album□c418 - chirp",
  "item.minecraft.music_disc_far": "album□c418 - far",
  "item.minecraft.music_disc_mall": "album□c418 - mall",
  "item.minecraft.music_disc_mellohi": "album□c418 - mellohi",
  "item.minecraft.music_disc_stal": "album□c418 - stal",
  "item.minecraft.music_disc_strad": "album□c418 - strad",
  "item.minecraft.music_disc_ward": "album□c418 - ward",
  "item.minecraft.music_disc_11": "album□c418 - 11",
  "item.minecraft.music_disc_wait": "album□c418 - wait",
  "item.minecraft.music_disc_pigstep": "album□lena raine - pigstep",
  "item.minecraft.trident": "salapang□□kung nasa pangunahing kamay:□+8 lakas ng atake□-2.9 bilis ng atake",
  "item.minecraft.phantom_membrane": "lamad ng multo",
  "item.minecraft.nautilus_shell": "pungo ng karakol",
  "item.minecraft.heart_of_the_sea": "puso ng dagat",
  "item.minecraft.crossbow": "panudlang pana",
  "item.minecraft.suspicious_stew": "kahina-hinalang nilaga",
  "block.minecraft.loom": "habihan",
  "item.minecraft.flower_banner_pattern": "disenyo ng watawat□bulakak na charge",
  "item.minecraft.creeper_banner_pattern": "disenyo ng watawat□kargang kilabot",
  "item.minecraft.skull_banner_pattern": "disenyo ng watawat□bungong charge",
  "item.minecraft.mojang_banner_pattern": "disenyo ng watawat□bagay",
  "item.minecraft.globe_banner_pattern": "disenyo ng watawat□globo",
  "item.minecraft.piglin_banner_pattern": "disenyo ng watawat□nguso",
  "block.minecraft.composter": "taga-abono",
  "block.minecraft.barrel": "bariles",
  "block.minecraft.smoker": "lutuan",
  "block.minecraft.blast_furnace": "pugon ng panday",
  "block.minecraft.cartography_table": "mesa ng kartograpiya",
  "block.minecraft.fletching_table": "mesa ng tagagawa ng tunod",
  "block.minecraft.grindstone": "panghasa",
  "block.minecraft.lectern": "patungan ng libro",
  "block.minecraft.smithing_table": "mesa ng panday",
  "block.minecraft.stonecutter": "pamutol ng bato",
  "block.minecraft.bell": "kampana",
  "block.minecraft.lantern": "parol",
  "block.minecraft.soul_lantern": "kaluwan parol",
  "item.minecraft.sweet_berries": "mga matamis na berry",
  "block.minecraft.campfire": "apuyan",
  "block.minecraft.soul_campfire": "kaluwan apuyan",
  "block.minecraft.shroomlight": "kabuting-ilaw",
  "item.minecraft.honeycomb": "saray",
  "block.minecraft.bee_nest": "pugad ng bubuyog",
  "block.minecraft.beehive": "bahay-pukyutan",
  "item.minecraft.honey_bottle": "bote ng pulot-pukyutan",
  "block.minecraft.honey_block": "bloke ng pulot-pukyutan",
  "block.minecraft.honeycomb_block": "blokeng saray",
  "block.minecraft.lodestone": "batubalani",
  "block.minecraft.netherite_block": "blokeng impyer yaman",
  "block.minecraft.ancient_debris": "sinaunang yagit",
  "block.minecraft.target": "tudlaan",
  "block.minecraft.crying_obsidian": "lumuluhang obsidiyano",
  "block.minecraft.blackstone": "itim na bato",
  "block.minecraft.blackstone_slab": "tilang batong-itim",
  "block.minecraft.blackstone_stairs": "hagdanang batong-itim",
  "block.minecraft.gilded_blackstone": "eleganteng batong-itim",
  "block.minecraft.polished_blackstone": "makinis na batong-itim",
  "block.minecraft.polished_blackstone_slab": "makinis na batong-itim na tilad",
  "block.minecraft.polished_blackstone_stairs": "makinis na batong-itim na hagdanan",
  "block.minecraft.chiseled_polished_blackstone": "pinaitang makinis na batong-itim",
  "block.minecraft.polished_blackstone_bricks": "makinis na batong-itim na laryo",
  "block.minecraft.polished_blackstone_brick_slab": "makinis na batong-itim na laryong tilad",
  "block.minecraft.polished_blackstone_brick_stairs": "makinis na batong-itim na laryong hagdanan",
  "block.minecraft.cracked_polished_blackstone_bricks": "makinis na batong-itim na laryong sira",
  "block.minecraft.respawn_anchor": "pagbubuhayang angkla",
}
export const tl_ph = items; 
